var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "main user-layout-register",
      staticStyle: { width: "500px", "margin-left": "-100px" }
    },
    [
      _vm._m(0),
      _c(
        "a-form-model",
        { ref: "form", attrs: { model: _vm.model, rules: _vm.validatorRules } },
        [
          _c(
            "a-row",
            { staticStyle: { width: "100%" } },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "用户账号",
                    prop: "username",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      type: "text",
                      autocomplete: "false",
                      placeholder: "请输入用户账号",
                      maxLength: _vm.maxLength
                    },
                    model: {
                      value: _vm.model.username,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "username", $$v)
                      },
                      expression: "model.username"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-popover",
                {
                  attrs: {
                    placement: "rightTop",
                    trigger: "click",
                    visible: _vm.state.passwordLevelChecked
                  }
                },
                [
                  _c("template", { slot: "content" }, [
                    _c(
                      "div",
                      { style: { width: "240px" } },
                      [
                        _c(
                          "div",
                          { class: ["user-register", _vm.passwordLevelClass] },
                          [
                            _vm._v("强度："),
                            _c("span", [_vm._v(_vm._s(_vm.passwordLevelName))])
                          ]
                        ),
                        _c("a-progress", {
                          attrs: {
                            percent: _vm.state.percent,
                            showInfo: false,
                            strokeColor: _vm.passwordLevelColor
                          }
                        }),
                        _c("div", { staticStyle: { "margin-top": "10px" } }, [
                          _c("span", [
                            _vm._v(
                              "请至少输入 8 个字母、数字或特殊字符。请不要使用容易被猜到的密码。"
                            )
                          ])
                        ])
                      ],
                      1
                    )
                  ]),
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        prop: "password",
                        label: "密码",
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c("a-input-password", {
                        attrs: {
                          type: "password",
                          autocomplete: "false",
                          maxLength: _vm.maxLength,
                          placeholder: "至少8位密码，区分大小写"
                        },
                        on: { click: _vm.handlePasswordInputClick },
                        model: {
                          value: _vm.model.password,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "password", $$v)
                          },
                          expression: "model.password"
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    prop: "password2",
                    label: "再次输入密码",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input-password", {
                    attrs: {
                      type: "password",
                      autocomplete: "false",
                      placeholder: "确认密码",
                      maxLength: _vm.maxLength
                    },
                    model: {
                      value: _vm.model.password2,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "password2", $$v)
                      },
                      expression: "model.password2"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    prop: "realname",
                    label: "真实姓名",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: "请输入真实姓名",
                      readOnly: !!_vm.model.id,
                      maxLength: _vm.maxLength
                    },
                    model: {
                      value: _vm.model.realname,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "realname", $$v)
                      },
                      expression: "model.realname"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "工号",
                    prop: "workNo",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: "请输入工号",
                      maxLength: _vm.maxLength
                    },
                    model: {
                      value: _vm.model.workNo,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "workNo", $$v)
                      },
                      expression: "model.workNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "部门分配",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "selectedDeparts"
                  }
                },
                [
                  _c("j-select-depart", {
                    attrs: { multi: true, backDepart: true, treeOpera: true },
                    on: { back: _vm.backDepartInfo },
                    model: {
                      value: _vm.model.selectedDeparts,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "selectedDeparts", $$v)
                      },
                      expression: "model.selectedDeparts"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "申请使用应用",
                    prop: "selectedApplications",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("j-multi-select-tag", {
                    attrs: {
                      disabled: _vm.disableSubmit,
                      options: _vm.applicationOptions,
                      placeholder: "请选择应用"
                    },
                    model: {
                      value: _vm.model.selectedApplications,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "selectedApplications", $$v)
                      },
                      expression: "model.selectedApplications"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "头像",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("j-image-upload", {
                    staticClass: "avatar-uploader",
                    attrs: { text: "上传" },
                    model: {
                      value: _vm.model.avatar,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "avatar", $$v)
                      },
                      expression: "model.avatar"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "生日",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      placeholder: "请选择生日",
                      "disabled-date": _vm.disabledDate,
                      format: _vm.dateFormat,
                      getCalendarContainer: function(node) {
                        return node.parentNode
                      }
                    },
                    model: {
                      value: _vm.model.birthday,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "birthday", $$v)
                      },
                      expression: "model.birthday"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "性别",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c(
                    "a-select",
                    {
                      attrs: {
                        placeholder: "请选择性别",
                        getPopupContainer: function(target) {
                          return target.parentNode
                        }
                      },
                      model: {
                        value: _vm.model.sex,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "sex", $$v)
                        },
                        expression: "model.sex"
                      }
                    },
                    [
                      _c("a-select-option", { attrs: { value: 1 } }, [
                        _vm._v("男")
                      ]),
                      _c("a-select-option", { attrs: { value: 2 } }, [
                        _vm._v("女")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "邮箱",
                    prop: "email",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: "请输入邮箱",
                      maxLength: _vm.maxLength
                    },
                    model: {
                      value: _vm.model.email,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "email", $$v)
                      },
                      expression: "model.email"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "手机号码",
                    prop: "phone",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: "请输入手机号码",
                      maxLength: _vm.maxLength
                    },
                    model: {
                      value: _vm.model.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "phone", $$v)
                      },
                      expression: "model.phone"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "座机",
                    prop: "telephone",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: "请输入座机",
                      maxLength: _vm.maxLength
                    },
                    model: {
                      value: _vm.model.telephone,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "telephone", $$v)
                      },
                      expression: "model.telephone"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "register-button",
                      attrs: {
                        size: "large",
                        type: "primary",
                        htmlType: "submit",
                        loading: _vm.registerBtn,
                        disabled: _vm.registerBtn
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.handleSubmit($event)
                        }
                      }
                    },
                    [_vm._v("提交申请\n        ")]
                  ),
                  _c(
                    "router-link",
                    { staticClass: "login", attrs: { to: { name: "login" } } },
                    [_vm._v("使用已有账户登录")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticStyle: { "font-weight": "bolder" } }, [
        _vm._v("用户申请")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }